import { DialogBody } from '@/components/Dialog'
import DialogActionButtonsSection from '../dialogs/components/DialogActionButtonsSection'
import { useTranslation } from 'react-i18next'

function ConfirmationDialogContents({
    onPositive,
    onNegative,
    positiveButtonText,
    negativeButtonText,
    positiveButtonDisabled = false,
    negativeButtonDisabled = false,
    positionY,
    textAlign = 'center',
    message,
}: {
    onPositive?: () => void
    onNegative?: () => void
    positiveButtonText?: string
    negativeButtonText?: string
    positiveButtonDisabled?: boolean
    negativeButtonDisabled?: boolean
    positionY?: number
    textAlign?: 'left' | 'center' | 'right'
    message: string
}) {
    const { t } = useTranslation()

    return (
        <div>
            <DialogBody>
                {message.split('\n').map((line, i) => {
                    return (
                        <div key={'text_' + i} className={'leading-6' + ` text-${textAlign}`}>
                            {line}
                        </div>
                    )
                })}
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText={negativeButtonText || t('Cancel') || 'Cancel'}
                rightButtonText={positiveButtonText || t('OK') || 'OK'}
                isLeftButtonDisabled={negativeButtonDisabled}
                isRightButtonDisabled={positiveButtonDisabled}
                onLeftButtonClicked={() => !negativeButtonDisabled && onNegative && onNegative()}
                onRightButtonClicked={() => !positiveButtonDisabled && onPositive && onPositive()}
            />
        </div>
    )
}

export default ConfirmationDialogContents
